<template>
    <div class="listeditor">
        <div class="listeditor__wrap">
            <app-controlhead
                :title="controlhead.title"
                :help="controlhead.help"
                :show-close="true"
                :show-remove="showRemove"
                :show-save="showSave"
                :show-global="showGlobal"
                :remove-text="controlhead.removeText"
                @close="close"
                @remove="remove"
            ></app-controlhead>

            <div class="listeditor__content">
                <component
                    v-bind:is="getListeditorSubpage"
                    v-bind:module-id="getActiveModuleId"
                    v-bind:listitem-id="getActiveListitemId"
                    v-bind:menu-id="getActiveMenuId"
                    @controlhead="controlhead = $event"
                ></component>
            </div>
        </div>

        <div class="listeditor__buttons">
            <button
                v-on:click.prevent="saveAndClose"
                :disabled="buttonDisabled"
                class="button button--icon-checkmark"
            >
                Übernehmen &amp; Schließen
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { OpenedRouteMixin } from '@/mixins/OpenedRouteMixin';
import Controlhead from '@/components/assorted/Controlhead';

import Pages from '@/components/lists/Pages.vue';
import Gallery from '@/components/lists/Gallery.vue';
import ImageSlider from '@/components/lists/ImageSlider.vue';
import Socials from '@/components/lists/Socials.vue';
import Album from '@/components/lists/Album.vue';
import Awards from '@/components/lists/Awards.vue';
import Partners from '@/components/lists/Partners.vue';
import Team from '@/components/lists/Team.vue';
import Documents from '@/components/lists/Documents.vue';
import Jobs from '@/components/lists/Jobs.vue';
import References from '@/components/lists/References.vue';
import Sectors from '@/components/lists/Sectors.vue';
import Services from '@/components/lists/Services.vue';
import Certifications from '@/components/lists/Certifications.vue';
import Texts from '@/components/lists/Texts.vue';
import Lists from '@/components/lists/Lists.vue';
import Brands from '@/components/lists/Brands.vue';
import Widgets from '@/components/lists/Widgets.vue';

export default {
    data() {
        return {
            controlhead: {}
        };
    },
    components: {
        'app-controlhead': Controlhead,
        Pages,
        Gallery,
        ImageSlider,
        Socials,
        Album,
        Awards,
        Partners,
        Team,
        Documents,
        Jobs,
        References,
        Sectors,
        Services,
        Certifications,
        Texts,
        Lists,
        Brands,
        Widgets
    },
    methods: {
        ...mapActions(['removeListItem', 'routeRemoveQuery', 'forgetDifferInRoute', 'saveAllData']),
        async save() {
            await this.forgetDifferInRoute(this.openedRoute);
            await this.saveAllData();
        },
        async saveAndClose() {
            await this.save();
            await this.close();
        },
        async close() {
            let args = [
                'listeditor',
                'listeditor_subpage',
                'listeditor_source',
                'listeditor_directedit',
                'listitem_id',
                'textpicker',
                'textpicker_namespace',
                'filemanager',
                'filemanager_source',
                'filemanager_accept',
                'filemanager_multiple',
                'fileeditor',
                'fileeditor_file_id'
            ];
            if (this.isListeditorDirectEdited) {
                args = args.concat([
                    'configurator',
                    'configurator_group',
                    'configurator_view',
                    'module_id'
                ]);
            }
            await this.routeRemoveQuery(args);
        },
        async remove() {
            await this.removeListItem({
                id: this.getActiveListitemId,
                source: this.getListeditorSource,
                confirm: true,
                save: true,
                route: true
            });
        }
    },
    computed: {
        ...mapGetters([
            'getListeditorSubpage',
            'getListeditorSource',
            'isListeditorDirectEdited',
            'getActiveModuleId',
            'getActiveListitemId',
            'differHasChangesInRoute',
            'differHasInvalidFieldsInRoute',
            'isListItemDeletable',
            'getActiveMenuId',
            'isPageDeletable'
        ]),
        showSave() {
            return (
                this.differHasChangesInRoute(this.openedRoute) &&
                !this.differHasInvalidFieldsInRoute(this.openedRoute)
            );
        },
        buttonDisabled() {
            return this.differHasInvalidFieldsInRoute(this.openedRoute);
        },
        showRemove() {
            if (!this.getActiveMenuId) {
                return this.isListItemDeletable({
                    id: this.getActiveListitemId,
                    source: this.getListeditorSource
                });
            } else {
                return this.isPageDeletable(this.getActiveListitemId);
            }
        },
        showGlobal() {
            return ![
                'Gallery',
                'ImageSlider',
                'Album',
                'Texts',
                'Lists',
                'References',
                'Widgets'
            ].includes(this.getListeditorSubpage);
        }
    },
    mixins: [OpenedRouteMixin],
    created() {
        this.controlhead = {};
    },
    watch: {
        openedRoute(newValue, oldValue) {
            if (oldValue !== null) {
                this.controlhead = {};
            }
        }
    }
};
</script>
